module.exports = __webpack_public_path__ + "webpc/img/icon_assets_2.b9b3a97c.png";